import React from "react";
import SelectWithSearch from "../SelectWithSearch/SelectWithSearch";
import { GoTrash } from "react-icons/go";
import { IoMdInformationCircle } from "react-icons/io";
import { FiX } from "react-icons/fi";

const EquipmentForm = ({
  onOpen,
  onClose,
  userName,
  todayDate,
  data,
  area,

  stockOptions,
  selectedStock,
  onSelectStock,
  onAddItem,

  selectedList,
  onRemoveOne,

  onSubmitHeader,
}) => {
  const [fechaRetiro, setFechaRetiro] = React.useState("");
  const [fechaDevolucion, setFechaDevolucion] = React.useState("");
  const [cargo, setCargo] = React.useState("");
  const [vpnBanka, setVpnBanka] = React.useState(false);
  const [motivo, setMotivo] = React.useState("");
  const [details, setDetails] = React.useState("");

  const [showHelp, setShowHelp] = React.useState(false);
  React.useEffect(() => {
    if (onOpen) {
      setFechaRetiro("");
      setFechaDevolucion("");
      setCargo("");
      setVpnBanka(false);
      setMotivo("");
      setDetails("");
      setShowHelp(false);
    }
  }, [onOpen]);

  if (!onOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmitHeader?.({
      date: todayDate,
      employee: userName,
      area: data?.[0]?.Employee?.area ?? "",
      fechaRetiro,
      fechaDevolucion,
      cargo,
      vpn: {
        banka: vpnBanka,
      },
      motivo,
      comments: details.trim(),
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl relative">
        {/* PANEL DE AYUDA (FUERA DEL FORM) */}
        <aside
          className={`absolute top-0 bottom-0 right-full w-[22rem] max-w-[90vw] bg-white border border-gray-200 rounded-lg shadow-lg
                      transform transition-all duration-300 ease-out
                      ${
                        showHelp
                          ? "translate-x-0 opacity-100"
                          : "-translate-x-3 opacity-0 pointer-events-none"
                      }`}
          role="dialog"
          aria-label="Ayuda para completar el retiro"
        >
          <div className="h-full flex flex-col">
            <div className="flex items-center justify-between p-3 border-b">
              <div className="flex items-center gap-2 text-gray-700">
                <IoMdInformationCircle />
                <h3 className="font-semibold">Informacion</h3>
              </div>
              <button
                type="button"
                onClick={() => setShowHelp(false)}
                className="p-1 rounded hover:bg-gray-100"
                aria-label="Cerrar ayuda"
              >
                <FiX />
              </button>
            </div>
            <div className="p-4 text-sm text-gray-600 leading-relaxed space-y-3 overflow-y-auto">
              <p>
                1) Elegí <strong>Fecha de Retiro</strong> y{" "}
                <strong>Fecha de Devolución</strong>.
              </p>
              <p>
                2) Seleccioná el <strong>equipo</strong> desde tu stock y
                presioná <em>Agregar</em> (importante a tener en cuenta, el
                equipo debe estar confirmado desde tu menu de inventario
                asignado).
              </p>
              <p>
                3) Indicá <strong>VPN</strong> si corresponde y cargá el{" "}
                <strong>motivo</strong>.
              </p>
              <p>
                4) Revisá la lista y hacé clic en{" "}
                <strong>Guardar retiro</strong>.
              </p>
              <p>
                <b>Nota: </b>
                Queda entendido que el responsable de la devolución en
                perfecto estado del equipo solicitado y en caso de pérdida o
                daño de este, es quien solicita el retiro del equipo.
              </p>
              <p>
                <b>Observación: </b>
                El equipo debe ser solicitado con al menos 1hs de
                anticipación antes de su salida. Expirado el plazo de
                devolución, el equipo debe ser devuelto inmediatamente en no más
                de 1 hora.
              </p>
              <p className="text-xs text-gray-500">
                Tip: podés quitar un ítem con el ícono de papelera.
              </p>
            </div>
          </div>
        </aside>

        {/* Cerrar */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl"
          onClick={onClose}
          type="button"
        >
          &times;
        </button>

        {/* Botón de ayuda (dentro del card) */}
        <button
          type="button"
          onClick={() => setShowHelp((v) => !v)}
          className="absolute top-3 left-3 inline-flex items-center gap-2 rounded-md border px-3 py-2 bg-white hover:bg-gray-50 text-gray-700"
          title="Abrir ayuda"
          aria-expanded={showHelp}
        >
          <IoMdInformationCircle className="text-xl" />
          <span className="hidden sm:inline">Info</span>
        </button>

        <div className="flex items-center justify-center mb-1">
          <h2 className="text-2xl font-bold mb-6 text-gray-700">
            Solicitud de Retiro de Equipo
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="overflow-y-auto max-h-[80vh] text-gray-700">
            {/* Empleado y fechas */}
            <div className="flex gap-2">
              <div className="w-1/3">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="empleado"
                >
                  Empleado
                </label>
                <input
                  id="empleado"
                  type="text"
                  value={userName}
                  className="w-full border rounded px-3 py-2 mb-4"
                  disabled
                />
              </div>

              <div className="w-1/3">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="fechaRetiro"
                >
                  Fecha de Retiro
                </label>
                <input
                  id="fechaRetiro"
                  type="date"
                  value={fechaRetiro}
                  min={todayDate}
                  required
                  onChange={(e) => setFechaRetiro(e.target.value)}
                  className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:border-custom-green-ccard-1 focus:ring-1 focus:ring-custom-green-ccard-1"
                />
              </div>

              <div className="w-1/3">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="fechaDevolucion"
                >
                  Fecha de Devolución
                </label>
                <input
                  id="fechaDevolucion"
                  type="date"
                  required
                  min={fechaRetiro || todayDate}
                  value={fechaDevolucion}
                  onChange={(e) => setFechaDevolucion(e.target.value)}
                  className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:border-custom-green-ccard-1 focus:ring-1 focus:ring-custom-green-ccard-1"
                />
              </div>
            </div>

            {/* Área y cargo */}
            <div className="flex gap-2">
              <div className="w-1/2">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="area"
                >
                  Área
                </label>
                <input
                  id="area"
                  type="text"
                  value={area}
                  className="w-full border rounded px-3 py-2 mb-4"
                  disabled
                />
              </div>

              <div className="w-1/2">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="cargo"
                >
                  Cargo
                </label>
                <input
                  id="cargo"
                  type="text"
                  value={cargo}
                  required
                  onChange={(e) => setCargo(e.target.value)}
                  className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:border-custom-green-ccard-1 focus:ring-1 focus:ring-custom-green-ccard-1"
                />
              </div>
            </div>

            {/* Selector de equipo (sin cantidad) + botón Agregar */}
            <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end mb-4">
              <div className="w-full">
                <label
                  htmlFor="equipo"
                  className="block text-sm font-medium mb-1"
                >
                  Equipo (selecciona del stock confirmado previamente en tu
                  inventario)
                </label>

                <SelectWithSearch
                  required
                  options={stockOptions}
                  value={selectedStock}
                  onChange={onSelectStock}
                  placeholder="Selecciona equipo a retirar…"
                  displayField="label"
                />
              </div>

              <button
                type="button"
                className="h-[42px] bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 rounded-lg disabled:opacity-50"
                onClick={onAddItem}
                disabled={!selectedStock || selectedStock?.remaining <= 0}
                title="Agregar 1 unidad del equipo seleccionado"
              >
                Agregar
              </button>
            </div>

            {/* Panel de Ítems seleccionados*/}
            <div className="mb-6">
              <h3 className="font-semibold mb-2">Ítems seleccionados</h3>
              {!selectedList || selectedList.length === 0 ? (
                <div className="text-sm text-gray-500 border rounded p-3">
                  No hay ítems aún. Seleccioná un equipo y presioná “Agregar”.
                </div>
              ) : (
                <div className="overflow-x-auto border rounded">
                  <table className="min-w-full text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-left p-2">Equipo</th>
                        <th className="p-2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedList.map((row) => (
                        <tr key={row.stockId} className="border-t">
                          <td className="p-2">{row.description}</td>
                          <td className="p-2 text-right">
                            <button
                              type="button"
                              className="text-red-600 hover:underline"
                              onClick={() => onRemoveOne(row.stockId)}
                              title="Quitar 1 unidad"
                            >
                              <GoTrash className="size-6" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* VPN y motivo */}
            {/* <div className="flex gap-2">
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">
                  VPN a Utilizar
                </label>
                <div className="flex items-center">
                  <input
                    id="vpnBanka"
                    type="checkbox"
                    checked={vpnBanka}
                    onChange={(e) => setVpnBanka(e.target.checked)}
                    className="mr-2"
                  />
                  <label htmlFor="vpnBanka">VPN Banka</label>
                </div>
              </div>

              <div className="w-1/2">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="motivoRetiro"
                >
                  Motivo de retiro de equipo
                </label>
                <input
                  id="motivoRetiro"
                  type="text"
                  value={motivo}
                  required
                  onChange={(e) => setMotivo(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-custom-green-ccard-1 focus:ring-1 focus:ring-custom-green-ccard-1"
                />
              </div>
            </div> */}

            {/* Comentarios */}
            <label
              className="block text-sm font-medium mb-1 mt-4"
              htmlFor="detalle"
            >
              Comentarios (Opcional)
            </label>
            <textarea
              id="detalle"
              rows={4}
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              placeholder="Notas o detalles de la solicitud…"
              className="w-full px-3 py-2 mb-6 resize-y border border-gray-300 rounded focus:outline-none focus:border-custom-green-ccard-1 focus:ring-1 focus:ring-custom-green-ccard-1"
            />

            {/* Botones */}
            <div className="flex justify-between">
              <button
                type="button"
                onClick={onClose}
                className="bg-gray-500 hover:bg-gray-600 font-bold text-white py-3 px-4 rounded-lg"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="bg-custom-green-ccard-1 hover:bg-custom-green-ccard-2 font-bold text-white py-3 px-4 rounded-lg disabled:opacity-50"
                disabled={!selectedList || selectedList.length === 0}
              >
                Guardar retiro
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EquipmentForm;
